const ArrowMarker = ({
                        rotation = 0, // degrees, clockwise
                      }) => {
  if (rotation === 'C') {
    return (
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(16,16) scale(0.6)">
          <circle className="map-marker-shape" cx="40" cy="40" r="28" />
          <circle className="map-marker-centre-dot" cx="40" cy="40" r="7" />
        </g>
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
      <g transform={`rotate(${rotation}, 40, 40)`}>
        <g transform="translate(16,16) scale(0.6)">
          <polygon className="map-marker-shape" points="
            40,5
            62,35
            48,35
            48,75
            32,75
            32,35
            18,35
          "/>
        </g>
      </g>
    </svg>
  );
};

export default ArrowMarker;
